class Modal {
    constructor(modalContainer) {
        this.container = modalContainer;
        this.content =  this.container.querySelector('.u-modal__content');
        this.contentBackup = this.content.cloneNode(true);
        this.headline = '';
    }

    handleModal = (type, state, data) => {
        this.body = document.querySelector('body');
        // state open | close
        if (state === 'open') {
            this.container.classList.add('is--open');

            if (type === 'content' && data) {
                this.setContent(data);
            }

            if (type === 'person') {
                this.content.querySelector('#modalId').value = data.id;
                this.content.querySelector('#modalContract').value = data.contract;
                this.headline = data.headline;

                this.getPerson(data.id, data.contract);
            }

            this.close = this.container.querySelectorAll('.u-modal__close, .u-modal__close-icon') || '';
            this.save = this.container.querySelector('.u-modal__save') || '';

            if ( this.container && this.container.classList.contains('is--open') ) {

                if (this.close) {
                    this.close.forEach((element) => element.addEventListener('click', (evt) => {
                        evt.preventDefault();

                        this.handleModal(type, 'close');
                    }));
                }

                if (this.save) {
                    this.save.addEventListener('click', (evt) => {
                        evt.preventDefault();
                        let form = this.content.querySelector('form');

                        fetch( form.action, {method:'post', body: new FormData(form)})
                            .then((response) => {
                                if (!response.ok) {
                                    throw new Error(`HTTP error! Status: ${response.status}`);
                                }

                                return response;
                            })
                            .then((response) => {
                                this.handleModal(type, 'close');

                                window.location.replace(window.location.href);
                            });
                    });
                }
            }

            this.body.classList.add('modal-open');
        } else {
            if (type == 'content') {
                this.setContent('');
            }

            if (type == 'person') {
                this.content.innerHTML = this.contentBackup.innerHTML;
            }

            this.container.classList.remove('is--open');
            this.close.forEach((element) => element.removeEventListener('click', () => {}) );
            this.body.classList.remove('modal-open');
        }
    };

    setContent = (content) => {
        this.container.querySelector('.u-modal__content').innerHTML = content;
    };

    getPerson = (id, contract) => {
        // get person data from api
        fetch(`/api/customer/get?id=${id}&contract=${contract}`, { method: 'GET', cache: 'no-cache' })
            .then(response => response.json())
            .then(data => {
                this.setPersonData(data);
            })
            .catch(error => console.log('error', error));
        // let data = `{"success":true,"data":{"salutation":"Herr","firstname":"Roland","lastname":"Heuberger","day":"01","month":"02","year":"1970","street":"Zionskirchstr.","housenumber":"17","zip":"10119","place":"Berlin","phone":null,"email":null,"hiName":"","hiNumber":""}}`;
        // this.setPersonData(JSON.parse(data));
    }

    setPersonData = (data) => {
        let localContent = this.content.innerHTML;

        if (typeof data.success !== 'undefined' && data.success === true) {
            let dataObj = data.data;

            dataObj.headline = this.headline;

            // set text fields
            for (let element in dataObj) {
                let regex = new RegExp("#" + element + "#");

                if (dataObj[element] !== null) {
                    localContent = localContent.replace(regex, dataObj[element]);
                } else {
                    localContent = localContent.replace(regex, '');
                }
            }

            this.content.innerHTML = localContent;

            let birthday = false;
            let hiName = false;
            // set selects and show/remove hidden fields
            for (let element in dataObj) {
                // set salutation select
                if (element === 'salutation') {
                    this.content.querySelector('#' + element).value = dataObj[element];
                }

                // set birthday selects
                if (['day', 'month', 'year'].includes(element) && dataObj['day'] && dataObj['month'] && dataObj['year']) {
                    this.content.querySelector('.birthday').classList.remove('hidden');

                    if (dataObj[element] !== null) {
                        this.content.querySelector('#' + element).value = parseInt(dataObj[element], 10);
                    }

                    birthday = true;
                }

                // show / remove Health ensurents fields
                if (['hiName', 'hiNumber'].includes(element) && dataObj[element]) {
                    this.content.querySelector('.hiName').classList.remove('hidden');
                    hiName = true;
                }
            }

            if (!birthday)  this.content.querySelector('.birthday').innerHTML = '';
            if (!hiName)    this.content.querySelector('.hiName').innerHTML = '';
        }
    }

}

export { Modal };